import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-number-of-tabs-panel';

export default function PosterEditorNumberOfTabsModal(): ReactElement<any> {
  const height = '142px';
  const maxWidth = '900px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_NUMBER_OF_TABS_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
      bottomSheetCloseThreshold={120}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-number-of-tabs-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorNumberOfTabsModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_NUMBER_OF_TABS_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
